module.exports = __webpack_public_path__ + "static/media/padi-logo-dark.279de9d7.png";